import { render, staticRenderFns } from "./DigitalTab.vue?vue&type=template&id=28545921"
import script from "./DigitalTab.vue?vue&type=script&lang=js"
export * from "./DigitalTab.vue?vue&type=script&lang=js"
import style0 from "./DigitalTab.vue?vue&type=style&index=0&id=28545921&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports